'use es6';

import PortalIdParser from 'PortalIdParser';
import { hubletApi, resolveApi } from 'hub-http/middlewares/core';
export const BASE_API_URL = `https://${resolveApi(hubletApi('api', 'hubspot'))}`;
export function getOrigin() {
  const {
    location
  } = window;
  const portString = location.port ? `:${location.port}` : '';
  return location.origin || `${location.protocol}//${location.hostname}${portString}`;
}
export function buildPortalUrl(path = '') {
  const origin = getOrigin();
  const portalId = PortalIdParser.get();
  return `${origin}${path.replace('$portalId', portalId)}`;
}
export function getMarketplaceUrl() {
  return buildPortalUrl('/marketplace/$portalId/products');
}